export const ADD_CHANNELS = "add_channels";
export const UPLOAD_MENU = "upload_menu";
export const SETUP_MIDDLEWARE = "setup_middleware";
export const APPROVE_BSP = "approve_bsp";
export const VERIFY_WHATSAPP_NUMBER = "verify_whatsapp_number";
export const VERIFY_FACEBOOK_ACCOUNT = "verify_facebook_account";
export const AUTHORISE_ACCOUNT = "authorise_account";
export const CREATE_FACEBOOK_CATALOGUE = "create_facebook_catalogue";
export const REVIEW_WHATSAPP_MENU = "review_whatsapp_menu";
export const DELIVERY_RADIUS_AND_CHARGES = "delivery_radius_and_charges";
export const COMPLETED = "completed";
